import { Row, Col } from "antd";
import PropTypes from "prop-types";
import Card from "./card";
import styles from "./style.module.scss";

const List = ({ list = [] }) => {
  return (
    <Row className={styles.listContainer} justify="space-between" align="top">
      {list?.length > 0 &&
        list.map((user, index) => (
          <Col key={index}>
            <Card user={user} />
          </Col>
        ))}
      {list.length % 3 === 2 && <div style={{ width: 240 }} />}
    </Row>
  );
};

List.propTypes = {
  list: PropTypes.array,
};
export default List;
